import * as React from "react";
import {BackendError} from "../types";
import {connect, MapStateToProps} from "react-redux";
import {RootState} from "@/store";

type OwnProps = {
    children: React.ReactNode;
};

type StateProps = {
    backendError: BackendError;
};

type Props = OwnProps & StateProps;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, RootState> = (store: RootState) => ({
    backendError: store.backendError,
});

export default connect(mapStateToProps)(({backendError, children}: Props) => (backendError ? null : children));
